import styled from 'styled-components'

export const Main = styled.div`
  display: grid;
  grid-template-columns: 172px 1fr 172px;
  grid-gap: 64px;
  margin-bottom: 64px;

  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
  }
`
export const VirginLogos = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	justify-content; flex-start;
	gap: 20px;
	
  @media (max-width: 1000px) {
		align-items: flex-start;
	}
`
export const Menu = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, calc(100% / 3)));
  align-items: flex-start;
  grid-gap: 32px;

  @media (max-width: 1000px) {
    grid-template-columns: minmax(0, 50%) minmax(0, 50%);
    grid-gap: 64px;
  }
  @media (max-width: 500px) {
    grid-template-columns: 1fr;
  }
`

export const FooterTermsWrapper = styled.div`
  a {
    color: var(--brand-secondary);
    text-decoration: underline;
  }

  p {
    font-weight: var(--font-light);
    font-size: 14px;
    line-height: 1.6;
  }
  word-wrap: break-word;
`

export const Heading = styled.div`
  font-weight: var(--font--regular);
  font-size: 18px;
  font-weight: 600;
  line-height: 1.6;
`
